module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/工作站图片.693f95df.png";